/* eslint-disable no-nested-ternary */
import { MdOutlineUpdate } from "react-icons/md";
import CustomPagination from "components/CustomPagination";
import { useEffect, useState } from "react";

import ModalCommonConfirm from "components/dialogCommon/templates/modalCommonConfirm";
import { IoTrash } from "react-icons/io5";
import { useRemoverUsuario } from "services/api/RoletaRecepcionista/delete-usuario";
import { useEncerrarInscricao } from "services/api/RoletaRecepcionista/post-encerrar-inscricao";
import { useSortearInscricao } from "services/api/RoletaRecepcionista/post-sortear-inscricao";
import { Tooltip } from "@mui/material";
import * as S from "./styles";
import * as IconsSVG from "../../../../../assets/iconsSVG";

interface ITabelaFilaProps {
  dataListarFila: any;
  refetchListarFila: () => void;
}

const TabelaFila = ({
  dataListarFila,
  refetchListarFila,
}: ITabelaFilaProps) => {
  const [isOpenSorteio, setIsOpenSorteio] = useState(false);
  const [isOpenEncerrarInscricoes, setIsOpenEncerrarInscricoes] =
    useState(false);
  const [isOpenDelete, setIsOpenDelete] = useState(false);

  const [page, setPage] = useState(1);
  const itemsPerPage = 12;
  const totalPages = Math.ceil(dataListarFila?.fila?.length / itemsPerPage);

  const [idCorretorSistemaOrigem, setIdCorretorSistemaOrigem] = useState("");

  const currentData = dataListarFila?.fila?.slice(
    (page - 1) * itemsPerPage,
    page * itemsPerPage
  );

  const fila = dataListarFila?.fila || [];

  useEffect(() => {
    setPage(1);
  }, [fila]);

  const handlePageChange = (newPage: number) => {
    setPage(newPage);
  };

  const { mutate: mutateRemover, isLoading: isLoadingRemover } =
    useRemoverUsuario();

  const openDelete = (idCorretorSistemaOrigem: string) => {
    setIdCorretorSistemaOrigem(idCorretorSistemaOrigem);
    setIsOpenDelete(true);
  };

  const handleDelete = () => {
    mutateRemover(
      {
        idRoletaCheckin: dataListarFila?.idRoletaCheckin,
        idCorretorSistemaOrigem,
      },
      {
        onSuccess: () => {
          setIsOpenDelete(false);
          refetchListarFila();
        },
      }
    );
  };

  const { mutate: mutateEncerrar, isLoading: isLoadingEncerrar } =
    useEncerrarInscricao();

  const openEncerrar = () => {
    setIsOpenEncerrarInscricoes(true);
  };

  const handleEncerrar = () => {
    mutateEncerrar(
      {
        idRoletaCheckin: dataListarFila?.idRoletaCheckin,
      },
      {
        onSuccess: () => {
          setIsOpenEncerrarInscricoes(false);
          refetchListarFila();
        },
      }
    );
  };

  const { mutate: mutateSortear, isLoading: isLoadingSortear } =
    useSortearInscricao();

  const openSorteio = () => {
    setIsOpenSorteio(true);
  };

  const handleSortear = () => {
    mutateSortear(
      {
        idRoletaCheckin: dataListarFila?.idRoletaCheckin,
      },
      {
        onSuccess: () => {
          setIsOpenSorteio(false);
          refetchListarFila();
        },
      }
    );
  };

  return (
    <S.Content>
      <S.Row>
        <S.Column>
          <S.ButtonOutlined onClick={() => refetchListarFila()}>
            <MdOutlineUpdate size={20} />
            Atualizar Fila de Inscrição
          </S.ButtonOutlined>
        </S.Column>
      </S.Row>
      <S.SpaceY space={48} />
      <S.BodyTable>
        {dataListarFila?.fila?.filter((item: any) => item.ativo).length ? (
          <>
            <S.Row style={{ gap: 4 }}>
              <S.TitlePosition>
                Quantidade de Posições na Fila:{" "}
              </S.TitlePosition>
              <S.SubTitlePosition>
                {dataListarFila?.quantidadePosicoes} |
              </S.SubTitlePosition>
              <S.TitlePosition>Fizeram Check-in: </S.TitlePosition>
              <S.SubTitlePosition>
                {dataListarFila?.fila?.filter((item: any) => item.ativo).length}
              </S.SubTitlePosition>
            </S.Row>
            <S.CardsContainer>
              {currentData
                .filter((item: any) => item.ativo)
                .map((item: any) => (
                  <S.Card key={item.id}>
                    <S.Column style={{ gap: 4 }}>
                      <S.Row style={{ gap: 8, alignItems: "center" }}>
                        <Tooltip
                          title={item.nomeCorretor}
                          placement="top"
                          arrow
                        >
                          <S.CardTitle>{item.nomeCorretor} </S.CardTitle>
                        </Tooltip>
                        <Tooltip
                          title={item.nomeEquipeCorretor}
                          placement="top"
                          arrow
                        >
                          <S.CardSubtitle>
                            {item.nomeEquipeCorretor &&
                              `(${item.nomeEquipeCorretor})`}
                          </S.CardSubtitle>
                        </Tooltip>
                      </S.Row>
                      <S.CardSubtitle>
                        Imobiliária: {item.nomeEmpresaVendas}
                      </S.CardSubtitle>
                    </S.Column>

                    <IoTrash
                      onClick={() => openDelete(item.idCorretorSistemaOrigem)}
                      color="#F43636"
                      size={20}
                      style={{ cursor: "pointer" }}
                    />
                  </S.Card>
                ))}
            </S.CardsContainer>
            <S.SpaceY space={48} />
            <CustomPagination
              count={totalPages}
              page={page}
              onPageChange={(_event, newPage) => handlePageChange(newPage)}
            />
          </>
        ) : (
          <S.WarningTitle>Nenhum corretor inscrito na fila!</S.WarningTitle>
        )}
        <S.SpaceY space={48} />
        <S.Row>
          <S.Column>
            {dataListarFila?.statusFila === 1 ? (
              <S.ButtonRed onClick={() => openEncerrar()}>
                Encerrar Inscrições na Fila
              </S.ButtonRed>
            ) : dataListarFila?.statusFila === 2 ? (
              <S.ButtonFade onClick={() => openSorteio()}>
                <IconsSVG.RoletaIcon color="#fff" width="35" height="35" />{" "}
                Sortear
              </S.ButtonFade>
            ) : null}
          </S.Column>
        </S.Row>
      </S.BodyTable>
      <ModalCommonConfirm
        icon={() => <IconsSVG.RoletaModalIcon />}
        message="Deseja realizar o Sorteio?"
        open={isOpenSorteio}
        setOpen={setIsOpenSorteio}
        onConfirm={() => handleSortear()}
        onCancel={() => setIsOpenSorteio(false)}
        isLoading={isLoadingSortear}
        confirmLabel="Sim"
        cancelLabel="Cancelar"
      />
      <ModalCommonConfirm
        icon={() => (
          <IconsSVG.FilaInscricaoIcon
            color1="#ED6C02"
            color2="#ED6C0266"
            color3="#FFEFE1"
          />
        )}
        message="Deseja encerrar as Inscrições da Fila?"
        open={isOpenEncerrarInscricoes}
        setOpen={setIsOpenEncerrarInscricoes}
        onConfirm={() => handleEncerrar()}
        onCancel={() => setIsOpenEncerrarInscricoes(false)}
        isLoading={isLoadingEncerrar}
        confirmLabel="Sim"
        cancelLabel="Cancelar"
      />
      <ModalCommonConfirm
        icon={() => <IconsSVG.DeleteIconModal />}
        message="Deseja excluir o corretor desta fila?"
        open={isOpenDelete}
        setOpen={setIsOpenDelete}
        onConfirm={() => handleDelete()}
        onCancel={() => setIsOpenDelete(false)}
        isLoading={isLoadingRemover}
        confirmLabel="Sim"
        cancelLabel="Cancelar"
      />
    </S.Content>
  );
};

export default TabelaFila;
